import { useParams } from 'react-router-dom'
import { useFilterOnConsolidateAgreement } from '../../hooks/useFilterOnConsolidateAgreement'
import { useChosenCompany } from '../../../../context/UserProvider'
import { useQuery } from 'react-query'
import { fetchFuelReportDetails } from '../../../../api/api'
import FuelReportDetailsTable from '../components/FuelTables/FuelReportDetailsTable'
import { ExcelExportButton } from '../components/ExcelExporter'
import { ConsolidateInvoiceSelect } from '../../../cars/components/V3/_shared/ConsolidateInvoiceSelect'
import { excelFuelReportDetailsColumns } from '../components/FuelTables/excelUtils'

const FuelReportDetails = () => {
  const company = useChosenCompany()
  const companyId = company?.id
  const { date } = useParams()
  const agreementFilter = useFilterOnConsolidateAgreement()

  const [year, month] = date ? date.split('-') : ['', '']

  const { data: response, isLoading } = useQuery(
    ['fuelReportDetails', companyId, year, month],
    () => fetchFuelReportDetails(company.id, year, month),
    { enabled: !!companyId },
  )

  //@ts-expect-error axios type issue
  const data = (Array.isArray(response) ? response : response?.data || []) as FuelReportDetails[]

  const filteredData = data.filter(agreementFilter('consolidatedInvoiceAgreement'))

  const columns = excelFuelReportDetailsColumns()
  const config = {
    columns,
    filename: `Drivstoffrapport_${year}_${month}.xlsx`,
    sheetName: `Drivstoffrapport_${year}_${month}`,
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col md:flex-row md:items-center gap-2 md:justify-between">
        <div className="flex flex-row justify-between ">
          <div className="flex flex-col md:items-center md:flex-row gap-2">
            <span className="text-xl font-medium text-primaryText">Detaljert drivstoffrapport</span>
            <span className=" hidden md:block text-lg text-secondaryText">/</span>
            <span className="text-lg text-secondaryText">
              {year}-{month}
            </span>
          </div>
          <div className="md:hidden">
            <ExcelExportButton data={data} config={config} />
          </div>
        </div>
        <div className="flex flex-row gap-2 w-full md:w-auto">
          <div className="flex-1 md:flex-none">
            <ConsolidateInvoiceSelect className="h-11 w-full" />
          </div>
          <div className="hidden md:block">
            <ExcelExportButton data={data} config={config} />
          </div>
        </div>
      </div>
      <FuelReportDetailsTable isLoading={isLoading} options={{ year, month }} data={filteredData} />
    </div>
  )
}

export default FuelReportDetails
